"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BlockOutline = {
    name: 'block',
    theme: 'outline',
    nameWithTheme: 'block-o',
    tag: 'svg',
    attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'icon',
        viewBox: '0 0 1024 1024'
    },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M856 376H648V168c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16v464c0 8.8 7.2 16 16 16h208v208c0 8.8 7.2 16 16 16h464c8.8 0 16-7.2 16-16V392c0-8.8-7.2-16-16-16zm-480 16v188H220V220h360v156H392c-8.8 0-16 7.2-16 16zm204 52v136H444V444h136zm224 360H444V648h188c8.8 0 16-7.2 16-16V444h156v360z'
            },
            children: []
        }
    ]
};
exports.default = BlockOutline;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/lib/outline/BlockOutline.js
// module id = 742
// module chunks = 0